import React, { memo } from "react";

const Notice = ({ title }) => {
    return (
        <div className="m-b-16">
            <strong className="m-r-6">Note:</strong>
            <span>{title}</span>
        </div>
    );
};

export default memo(Notice);
